import React from 'react';
import { Link } from 'react-router-dom';
import { Seo } from '../components/Seo';
export function NotFound() {
  return <div className="w-full bg-white" data-id="element-722" data-mp="w52j5rl1rsbt">
      <Seo title="Page Not Found | Reach Performance" description="The page you are looking for is not available. Browse Reach Performance programs, the fall schedule, and pricing in McKinney, TX." path="/404" data-id="element-723" data-mp="w647gxr2qbbh" />
      <section className="bg-reach-black py-24 md:py-32" data-id="element-724" data-mp="1a4u2m7uc20x7">
        <div className="mx-auto max-w-container px-4 text-center md:px-8" data-id="element-725" data-mp="1a27vuaf9npg1">
          <p className="mb-4 font-inter text-xs font-semibold uppercase tracking-[0.3em] text-reach-red-light" data-id="element-726" data-mp="1f1arx5d9qlbv">
            Error 404
          </p>
          <h1 className="mb-5 font-bebas text-5xl leading-none tracking-wide text-white md:text-7xl" data-id="element-727" data-mp="1nvyw0s73xwz3">
            This Page Does Not Exist
          </h1>
          <p className="mx-auto mb-10 max-w-xl font-inter text-base text-white/85 md:text-lg" data-id="element-728" data-mp="1swd42a8pl6x4">
            The link may be out of date. Here is where to go next.
          </p>
          <div className="mx-auto flex max-w-md flex-col items-stretch justify-center gap-4 sm:max-w-none sm:flex-row sm:items-center" data-id="element-729" data-mp="1nwn7jbmjbl8y">
            <Link to="/programs" className="btn-primary sm:w-auto" data-id="element-730" data-mp="1iz3toctr1ahj">
              View Fall Programs
            </Link>
            <Link to="/book" className="btn-secondary-dark sm:w-auto" data-id="element-731" data-mp="19wcec1xr5ukm">
              Book Free Athlete Evaluation
            </Link>
          </div>
        </div>
      </section>

      <section className="bg-white py-16" data-id="element-732" data-mp="26og2vcp2tiju">
        <div className="mx-auto max-w-3xl px-4 md:px-8" data-id="element-733" data-mp="22ki1swg6xxo5">
          <h2 className="mb-6 text-center font-bebas text-3xl tracking-wide md:text-4xl" data-id="element-734" data-mp="22n47eqjiu33q">
            Popular Pages
          </h2>
          <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2" data-id="element-735" data-mp="1svgnrbt7hqct">
            {[{
            to: '/',
            label: 'Sports performance training in McKinney'
          }, {
            to: '/programs',
            label: 'Fall programs and class times'
          }, {
            to: '/speed-school',
            label: 'Speed School on September 12 and 26'
          }, {
            to: '/fall-2026',
            label: 'Fall 2026 schedule and testing'
          }, {
            to: '/pricing',
            label: 'Training rates and private coaching'
          }, {
            to: '/contact',
            label: 'Contact Reach Performance'
          }].map(link => <li key={link.to} data-id="element-736" data-mp="2zp4nz9vkjaiy">
                <Link to={link.to} className="block border-b-4 border-transparent bg-reach-gray px-5 py-4 font-inter text-base text-reach-black transition-colors duration-200 hover:border-reach-red" data-id="element-737" data-mp="2zocty3hmdkus">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </div>
      </section>
    </div>;
}